{
  "id": "campaign-012",
  "name": "Lucky Nook",
  "seed": "campaign:12",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........HHH",
    "........HHH",
    "........___",
    ".......B.,,",
    "....B...#..",
    "...h..g....",
    "...........",
    "...........",
    "...........",
    ".*.........",
    "***........",
    "...........",
    "S.........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "rare",
      "x": 7,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 12,
  "biome": "backyard",
  "par": {
    "reel": 4622,
    "push": 3992,
    "selfPropelled": 3684,
    "tractor": 3310,
    "zeroTurn": 2509,
    "fairway": 1480
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 12
    }
  }
}
